import { render, staticRenderFns } from "./BaseGoodsCard.vue?vue&type=template&id=6e0df31c&"
import script from "./BaseGoodsCard.vue?vue&type=script&lang=js&"
export * from "./BaseGoodsCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseGoodsCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports